import RoutesMap from "../../route_control/RouteControl"
import {
    ModuleList,
    UserRoleList,
    ActionList,
    AddAction,
    UpdateAction,
    Permission,
    CompanyPermission,
    UserPermission
} from "../../pages/settings"

export const SettingsImport = {
    RoutesMap,
    ModuleList,
    UserRoleList,
    ActionList,
    AddAction,
    UpdateAction,
    Permission,
    CompanyPermission,
    UserPermission
}